<template>
    <span>
        <el-popover 
            :width="350" 
            trigger="click"
            @show="show = true"
            @hide="show = false">
            <template #reference>
                <el-icon><Avatar /></el-icon>
            </template>
            <ComAvatar v-if="show" />
        </el-popover>
    </span>
</template>

<script  setup lang="ts">
import { Avatar } from "@element-plus/icons-vue"
import ComAvatar from "@/components/layout/header/ComAvatar.vue"
import { ref } from "vue";

const show = ref(false)

</script>
